import * as React from 'react';

import request from '../../utils/request';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Tooltip,
  Typography
} from '@mui/material';
import { Icon } from '@iconify/react';
import trash2Outline from '@iconify/icons-eva/trash-2-outline';
import SnackbarAlert from '../common/SnackbarAlert';
import { LoadingButton } from '@mui/lab';
import Links from '@mui/material/Link';

export default function DeleteAlert({
  deleteopen,
  // eslint-disable-next-line
  deleteData,
  pageContent,
  deleteName,
  refetchApi,
  apiUrl,
  setDeleteOpen
}) {
  const [showSnackBarAlert, setShowSnackBarAlert] = React.useState({
    status: false,
    type: 'success',
    message: null
  });
  const [loader, setLoader] = React.useState(false);
  const removeData = () => {
    setLoader(true);
    request({
      url: apiUrl,
      method: 'delete'
    })
      .then((data) => {
        if (data.status) {
          setShowSnackBarAlert({
            status: true,
            type: 'success',
            message: `${deleteName} deleted`
          });
          setDeleteOpen(false);
          refetchApi();
        } else {
          setShowSnackBarAlert({
            status: true,
            type: 'error',
            message: data['message']
          });
        }
        setLoader(false);
      })
      .catch(
        function (err) {
          setShowSnackBarAlert({
            status: true,
            type: 'error',
            message: 'Something went wrong, Please try again after some time.'
          });
          setLoader(false);
        }.bind(this)
      );
  };

  const handleSnackbarClose = () => {
    setShowSnackBarAlert({ status: false, type: null, message: null });
  };
  return (
    <div>
      <SnackbarAlert
        showSnackBarAlert={showSnackBarAlert}
        handleSnackbarClose={handleSnackbarClose}
      />
      <Dialog
        open={deleteopen}
        onClose={() => setDeleteOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" style={{ textAlign: 'left' }}>
          {' '}
          <Grid
            container
            direction="row"
            justifyContent="left"
            alignItems="stretch"
            spacing={1}
          >
            <Grid style={{ textAlign: 'left' }} sx={{ mt: 2 }}>
              <Icon
                icon={trash2Outline}
                width={22}
                height={22}
                color="red"
                style={{ textAlign: 'left' }}
              />
              &nbsp;&nbsp;&nbsp;
            </Grid>

            <Grid sx={{ mt: 2.2 }}>
              {/* {pageContent.length < 24 ? (
                            <Typography variant="h6" color="black" style={{ textAlign: 'left' }}>
              Delete {pageContent}
            </Typography>
                          ) : (
                            <p>
                              {pageContent.substring(0, 24)}
                              ...
                              <Tooltip
                                placement="top-end"
                                title={pageContent}
                                arrow
                              >
                                <Links> Read More</Links>
                              </Tooltip>
                            </p>
                          )} */}

              <Typography
                variant="h6"
                color="black"
                style={{ textAlign: 'left',textTransform:'capitalize' }}
              >
                Delete {pageContent}
              </Typography>
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent>
          {deleteName?.length < 50 ? (
            <DialogContentText id="alert-dialog-description">
              Are you sure you want to delete {deleteName}?
            </DialogContentText>
          ) : (
            <p>
              <DialogContentText id="alert-dialog-description">
                Are you sure you want to delete {deleteName?.substring(0, 50)}
                ...
                <Tooltip placement="top-end" title={deleteName} arrow>
                  <Links> Read More</Links>
                </Tooltip>
                ?
              </DialogContentText>
            </p>
          )}
        </DialogContent>
        <DialogActions>
          <LoadingButton
            sx={{ mt: { xs: 2, md: 0 } }}
            loading={loader}
            variant="contained"
            type="submit"
            color="error"
            onClick={removeData}
            autoFocus
          >
            Delete
          </LoadingButton>
          <Button
            onClick={() => setDeleteOpen(false)}
            variant="contained"
            color="primary"
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
